import styled from "styled-components";
import { useState } from "react";

// Components
import FontAwesomeIcon from "../../../../components/common/FontAwesomeIcon";
import CommonButton from "../../../../components/common/CommonButton";
import QuestionsBody from "./questionsTest/QuestionsBody";

// Services
import { postTestAnswers } from "../../services/testApi";
import LoaderQuestions from "./formTest/LoaderQuestions";

const QuestionsTest = (props) => {

    const { handleNextPage, handleFinalPage, questions, loading, participant_id } = props;

    const [answers, setAnswers] = useState([]);

    const handleSendQuestions = async () => {
        // Aquí puedes agregar la lógica para enviar las respuestas
        handleNextPage();
        const answersToSend = {
            answers: answers
        }
        // Acá iría el POST
        const response = await postTestAnswers(participant_id, answersToSend);
        handleFinalPage(response)
    }

    const handleAddAnswer = (type, questionId, optionId) => {
        setAnswers(prevAnswers => {
            const existingAnswer = prevAnswers.find(a => a.question_id === questionId);
            
            if (type === "multiple_choice") {
                if (existingAnswer) {
                    // Si ya existe una respuesta para esta pregunta, actualizamos la lista de opciones
                    const currentOptions = Array.isArray(existingAnswer.selected_option_ids) 
                        ? existingAnswer.selected_option_ids 
                        : [existingAnswer.selected_option_ids];
                        
                    return prevAnswers.map(a => 
                        a.question_id === questionId 
                            ? { 
                                ...a, 
                                selected_option_ids: currentOptions.includes(optionId) 
                                    ? currentOptions.filter(id => id !== optionId) 
                                    : [...currentOptions, optionId]
                            }
                            : a
                    );
                } else {
                    // Si es una nueva respuesta, la agregamos
                    return [...prevAnswers, { 
                        question_id: questionId, 
                        type, 
                        selected_option_ids: [optionId] 
                    }];
                }
            } else if (type === "open_question") {
                if (existingAnswer) {
                    return prevAnswers.map(a => 
                        a.question_id === questionId 
                            ? { ...a, answer: optionId }
                            : a
                    );
                } else {
                    return [...prevAnswers, { 
                        question_id: questionId, 
                        type, 
                        answer: optionId 
                    }];
                }
            } else {
                // Para otros tipos de preguntas, mantenemos el comportamiento actual
                if (existingAnswer) {
                    return prevAnswers.map(a => 
                        a.question_id === questionId 
                            ? { ...a, selected_option_ids: optionId }
                            : a
                    );
                } else {
                    return [...prevAnswers, { 
                        question_id: questionId, 
                        type, 
                        selected_option_ids: optionId 
                    }];
                }
            }
        });
    };

    if (loading) {
        return <LoaderQuestions />
    }

    return (
        <Container>
            <label>Responde las siguientes preguntas:</label>
            <QuestionsBody questions={questions} handleAddAnswer={handleAddAnswer} answers={answers} />
            <Footer>
                <CommonButton
                    label="Enviar respuestas"
                    variant="filled"
                    onClick={handleSendQuestions}
                    disabled={answers.length === 0}
                    Icon={() => (
                        <div>
                            <FontAwesomeIcon icon="fa-light fa-paper-plane" size={24} />
                        </div>
                    )}
                />
            </Footer>
        </Container>
    )
}

export default QuestionsTest;

const Container = styled.div`
    width: 60%;
    height: fit-content;
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 2rem;
    background-color: #fff;
    padding: 2rem;
    border-radius: 30px;

    label {
        width: 100%;
        color: #535353;
        font-size: 16px;
    }
`

const Footer = styled.div`
    width: 100%;
    display: flex;
    justify-content: end;
    align-items: center;
`